var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 5.84748C8.3141 6.10339 7.75 6.82154 7.75 7.5C7.75 8.17846 8.3141 8.89661 9.25 9.15252V5.84748Z",
    fill: "#FFC327"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 10.8475V14.1525C11.6859 13.8966 12.25 13.1785 12.25 12.5C12.25 11.8215 11.6859 11.1034 10.75 10.8475Z",
    fill: "#FFC327"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 3.25C10.4142 3.25 10.75 3.58579 10.75 4V4.31673C12.3804 4.60867 13.75 5.83361 13.75 7.5C13.75 7.91421 13.4142 8.25 13 8.25C12.5858 8.25 12.25 7.91421 12.25 7.5C12.25 6.82154 11.6859 6.10339 10.75 5.84748V9.31673C12.3804 9.60867 13.75 10.8336 13.75 12.5C13.75 14.1664 12.3804 15.3913 10.75 15.6833V16C10.75 16.4142 10.4142 16.75 10 16.75C9.58579 16.75 9.25 16.4142 9.25 16V15.6833C7.61957 15.3913 6.25 14.1664 6.25 12.5C6.25 12.0858 6.58579 11.75 7 11.75C7.41421 11.75 7.75 12.0858 7.75 12.5C7.75 13.1785 8.3141 13.8966 9.25 14.1525V10.6833C7.61957 10.3913 6.25 9.16639 6.25 7.5C6.25 5.83361 7.61957 4.60867 9.25 4.31673V4C9.25 3.58579 9.58579 3.25 10 3.25Z",
    fill: "#FFC327"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/MoneyIcon.82bf2eb4ad28c5a7fdff48ee3a32353c.svg";
export { ForwardRef as ReactComponent };